import { useState } from "react";
import { aboutFaqList } from "@/mocks/faq";

export default function AboutFaq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="scroll-mt-32">
      <div className="mb-8">
        <span className="inline-flex items-center gap-1.5 rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-800">
          <span className="flex h-3 w-3 items-center justify-center">
            <i className="ri-question-line text-[11px]"></i>
          </span>
          常见问题
        </span>
        <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
          关于团队与内容流程
        </h2>
      </div>

      <div className="mx-auto flex max-w-3xl flex-col gap-3">
        {aboutFaqList.map((item, index) => {
          const isOpen = openIndex === index;
          return (
            <div
              key={item.question}
              className="overflow-hidden rounded-card border border-background-200/80 bg-background-50"
            >
              <h3>
                <button
                  type="button"
                  onClick={() => setOpenIndex(isOpen ? null : index)}
                  aria-expanded={isOpen}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left transition-colors duration-200 hover:bg-background-100/70"
                >
                  <span className="text-sm font-medium text-foreground-900 md:text-base">
                    {item.question}
                  </span>
                  <span
                    className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-full transition-colors duration-200 ${
                      isOpen
                        ? "bg-secondary-500 text-background-50"
                        : "bg-background-200 text-foreground-600"
                    }`}
                  >
                    <i className={`${isOpen ? "ri-subtract-line" : "ri-add-line"} text-sm`}></i>
                  </span>
                </button>
              </h3>
              {isOpen && (
                <p className="animate-fade-in border-t border-background-200/70 px-5 py-4 text-sm leading-relaxed text-foreground-600">
                  {item.answer}
                </p>
              )}
            </div>
          );
        })}
      </div>
    </section>
  );
}